import { HeroPrimary } from "../headers/HeroPrimary";
import { SectionBlockMediaFeatured } from "../sections/blocks/SectionBlockMediaFeatured";
import { SectionBlockMediaCTA } from "../sections/blocks/SectionBlockMediaCTA";
import { SectionBlockMediaCTAInline } from "../sections/blocks/SectionBlockMediaCTAInline";
import { SectionGridCardTiles } from "../sections/grids/SectionGridCardTiles";
import { SectionBlockStats } from "../sections/blocks/SectionBlockStats";
import WrenchIcon from "~/assets/svgs/icons/WrenchIcon";
import { HardHatIcon } from "~/assets/svgs/icons/HardHatIcon";
import { LinkIcon } from "~/assets/svgs/icons/LinkIcon";
import { GearFlagIcon } from "~/assets/svgs/icons/GearFlagIcon";
import { WrapperComponents } from "../wrappers/WrapperComponents";
import { CasesManaged } from "~/assets/svgs/icons/CasesManaged";
import { Asist } from "~/assets/svgs/icons/Asist";
import { Connector } from "~/assets/svgs/icons/Connector";
import { Inducted } from "~/assets/svgs/icons/Inducted";
import { SectionBlockMediaCalloutCard } from "../sections/blocks/SectionBlockMediaCalloutCard";
import { SectionBlockPinnedMediaItems } from "../sections/blocks/SectionBlockPinnedMediaItems";
import { SectionBlockStatsAlt } from "../sections/blocks/SectionBlockStatsAlt";
import { SectionBlockCallout } from "../sections/blocks/SectionBlockCallout";
import { SectionBlockMediaItem } from "../sections/blocks/SectionBlockMediaItem";
import { SectionCardCarousel } from "../sections/blocks/SectionCardCarousel";
import { CardResearch } from "../components/cards/CardResearch";
import { CardTile } from "../components/cards/CardTile";
import { CardCarousel } from "../components/cards/CardCarousel";
import { truncate } from "~/styles/functions";

export interface ITemplatePageHome {
  data: any;
}

export default function TemplatePageHome({ data }: ITemplatePageHome) {
  const {
    heroPrimary,
    sectionBlockPinnedMediaItems,
    sectionBlockStatsAlt,
    featuredImage,
    sectionBlockCallout,
    sectionBlockCallout2,
    callToAction,
    sectionBlockFeaturedResearch,
    featuredResearch,
    sectionBlockCardCarousel,
  } = data;

  // console.log("templatePageHome", data)

  return (
    <>
      {heroPrimary && <HeroPrimary data={heroPrimary} />}
      <WrapperComponents>
        {sectionBlockCallout && (
          <SectionBlockCallout data={sectionBlockCallout} theme="dark" />
        )}
        {sectionBlockStatsAlt && (
          <SectionBlockStatsAlt data={sectionBlockStatsAlt} />
        )}

        {sectionBlockCardCarousel &&
          sectionBlockCardCarousel.items.length > 0 && (
            <SectionCardCarousel
              theme="colour"
              data={{
                text: sectionBlockCardCarousel.text,
                title: sectionBlockCardCarousel.title,
                link: sectionBlockCardCarousel.link,
              }}
            >
              {Array.isArray(sectionBlockCardCarousel.items) &&
                sectionBlockCardCarousel.items.map(
                  (item: any, index: number) => (
                    <CardCarousel
                      heightFull
                      theme="light"
                      card={{
                        title: item.title,
                        text: item.text,
                      }}
                      key={index}
                      index={index + 1}
                    />
                  ),
                )}
            </SectionCardCarousel>
          )}

        {sectionBlockPinnedMediaItems && (
          <SectionBlockPinnedMediaItems data={sectionBlockPinnedMediaItems} />
        )}
        {featuredImage && (
          <SectionBlockMediaFeatured
            data={{
              image: featuredImage,
            }}
          />
        )}
        {sectionBlockCallout2 && (
          <SectionBlockCallout data={sectionBlockCallout2} theme="colour" />
        )}
        {sectionBlockFeaturedResearch && featuredResearch && (
          <SectionCardCarousel
            theme="light"
            data={{
              title: sectionBlockFeaturedResearch.title,
              text: sectionBlockFeaturedResearch.description,
              link: sectionBlockFeaturedResearch.link,
            }}
          >
            {Array.isArray(featuredResearch) &&
              featuredResearch.map((paper: any, index: number) => (
                <CardCarousel
                  theme="colour"
                  truncateLength={60}
                  heightFull
                  fontSize="xs"
                  card={{
                    title: paper.title,
                    text: `Overview: ${truncate(paper.text, 400)}`,
                    link: {
                      _type: "link",
                      newTab: true,
                      slug: paper.researchPaperExternalLink
                        ? paper.url
                        : paper.document?.asset?.url || null,
                      text: paper.researchPaperExternalLink
                        ? "View Research"
                        : "Read Research",
                    },
                  }}
                  key={index}
                />
              ))}
          </SectionCardCarousel>
        )}
        {callToAction && <SectionBlockMediaItem data={callToAction} />}
      </WrapperComponents>
    </>
  );
}
